<ng-container *ngIf="proposalSlip$|async as proposalSlip; else loading">
  <app-proposal-slip class="w-100" [proposalSlip]="proposalSlip"></app-proposal-slip>
</ng-container>
<ng-template #loading>
  <div class="w-100 d-flex justify-content-center mb-2">
    <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
  </div>
</ng-template>

